import { render, staticRenderFns } from "./template.html?vue&type=template&id=661ef602&scoped=true&external"
import script from "./change-profile.vue?vue&type=script&lang=js"
export * from "./change-profile.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=661ef602&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661ef602",
  null
  
)

export default component.exports